import TaskForm, { TaskField } from "../TaskForm";
import ParcelService from "../../../services/parcelService";
import { FertilizerTask } from "../../../interfaces/FertilizerTask";

export default function FertilizerCreateForm(props: any) {
    const parcelService = new ParcelService();

    const fields: TaskField[] = [
    { name: "kind", label: "Art", type: "text", required: true },
    { name: "quantityPerParcel", label: "Menge (pro/ha)", type: "number", required: true },
    { name: "date", label: "Datum", type: "date", required: true },
    { name: "note", label: "Notizen", type: "textarea" }
] as const;

    const defaultState: FertilizerTask = {
        id: "",
        kind: "",
        quantityPerParcel: 0,
        date: new Date(),
        note: ""
    };

    return (
        <TaskForm<FertilizerTask>
            title="Düngen"
            fields={fields}
            isNew={props.isNew}
            task={props.task}
            defaultState={defaultState}
            onSubmit={async (data) => {
                if (props.isNew) {
                    await parcelService.createFertilizerTask(props.parcelId, props.cycleId, data);
                } else {
                    await parcelService.updateFertilizerTask(props.parcelId, props.cycleId, Number(data.id), data);
                }
                props.onSave(data);
            }}
            readOnly={props.readOnly}
        />
    );
}
